import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import getPrice from 'store/price/selector/getPrice';
import setPricesToFetchOperation from 'store/price/operation/setPricesToFetchOperation';
import fetchPricesOperation from 'store/price/operation/fetchPricesOperation';
import { PricesToFetch } from 'store/price/types';
import getCommonProductRequestParams from '../selector/getCommonProductRequestParams';
import getBundleGroups from '../selector/getBundleGroups';
import getEncPublicDesignId from '../selector/getEncPublicDesignId';

const fetchBundleGroupsPricesOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const bundleGroups = getBundleGroups(store);
    const encPublicDesignId = getEncPublicDesignId(store);
    const { categoryId } = getCommonProductRequestParams(store);
    if (!categoryId) {
      return;
    }

    const pricesToFetch: PricesToFetch = {};

    bundleGroups.forEach((bGroup) => {
      bGroup.items?.forEach(({ productId }) => {
        if (getPrice(store, categoryId, productId, 1)) {
          return;
        }
        if (!pricesToFetch[categoryId]) {
          pricesToFetch[categoryId] = {
            categoryId,
            productIds: [],
            encryptedDesignId: encPublicDesignId || '',
          };
        }
        pricesToFetch[categoryId].productIds.push(productId);
      });
    });

    if (Object.keys(pricesToFetch).length) {
      dispatch(setPricesToFetchOperation(pricesToFetch));
      dispatch(fetchPricesOperation());
    }
  };

export default fetchBundleGroupsPricesOperation;
